import { render, staticRenderFns } from "./detailsindetail.vue?vue&type=template&id=84a2d51c&slot=title"
import script from "./detailsindetail.vue?vue&type=script&lang=js"
export * from "./detailsindetail.vue?vue&type=script&lang=js"
import style0 from "./detailsindetail.vue?vue&type=style&index=0&id=84a2d51c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports